module.exports = __webpack_public_path__ + "static/img/icon-dakejian-large.f10b90a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qcxj/icon-dakejian-large.png
// module id = 979
// module chunks = 0